import React from 'react';
import { IconProps } from '.';

const SvgBoxCartFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z' />
      <path
        fill='#fff'
        d='M5 5.4a.6.6 0 0 0 0 1.2h.784l.312 2.05 1.04 7.433a.6.6 0 0 0 .594.517h9.1a.6.6 0 0 0 .593-.507l1.17-7.436a.6.6 0 1 0-1.186-.186l-1.09 6.929H8.252l-.968-6.92-.39-2.57A.6.6 0 0 0 6.3 5.4H5ZM10.7 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM15 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'
      />
      <path
        fill='#fff'
        d='M12.85 7a.55.55 0 0 0-1.1 0v4.645l-1.556-1.6a.55.55 0 0 0-.788.767l2.5 2.571a.55.55 0 0 0 .788 0l2.5-2.571a.55.55 0 1 0-.788-.767l-1.556 1.6V7Z'
      />
    </svg>
  );
};

export default SvgBoxCartFill;
